import { formatCalendarDateForInput, calculateAge, formatCalendarDate } from "../../Utils/helper";
import avatarImage from "../../assets/images/avatar.svg";
import birthdayIcon from "../../assets/images/birthdayicon.svg";

import "./ClientDetails.css";

const ClientDetails = ({ client, className = "", showBirthday = true }) => {
  if (!client || client.isEmpty) return null;

  const name = [client.firstName ?? client.first_name, client.lastName ?? client.last_name]
    .filter(Boolean)
    .join(" ");
  const profilePic =
    client.profile_pic_63p ||
    client.profile_pic ||
    client.avatar_url ||
    client.profile_pic_29p ||
    client.profilePic ||
    client.profile_pic_19p;
  const birthday = formatCalendarDate(client.birthday);
  const hasBirthday =
    /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(birthday) &&
    Boolean(formatCalendarDateForInput(client.birthday));
  const age = hasBirthday ? calculateAge(client.birthday) : "";

  if (!name && !profilePic && !hasBirthday) return null;

  return (
    <div className={`client-details ${className}`}>
      <span className="client-details-identity">
        <img
          className="client-details-avatar"
          src={profilePic || avatarImage}
          width="19"
          height="19"
          alt=""
        />
        {name && (
          <span className="client-details-name" title={name}>
            {name}
          </span>
        )}
      </span>
      {showBirthday && hasBirthday && (
        <span className="client-details-birthday" aria-label={`Birthday: ${birthday}`}>
          <img
            src={birthdayIcon}
            style={{
              minWidth: "15px",
            }}
            width="15"
            height="15"
            alt=""
          />
          <span>{birthday}</span>
        </span>
      )}
      {showBirthday && Number.isInteger(age) && (
        <span className="client-details-age d-flex align-items-center gap-1">
          <p className="text-primary-25">age</p> {age}
        </span>
      )}
    </div>
  );
};

export default ClientDetails;
